import { MoveModel } from './move';
import { DataListModel } from '../data';
export interface MoveListModel extends DataListModel {
  results: MoveModel[];
}
